import * as React from "react";
import { MultiSelect } from "components/MultiSelect";
import { FormFieldProps } from "components/form";
import { MachineChip, MissingChip } from "components/Chips";
import ReferenceDataItem from "client/resources/referenceDataItem";
import { ChipIcon } from "components/Chips";
import Lookup from "../Lookup";
import { SelectItem } from "../VirtualListWithKeyboard/SelectItem";

interface MachineMultiSelectProps extends FormFieldProps<string[]> {
    items: ReferenceDataItem[];
    openOnFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
    hideFloatingLabel?: boolean;
}

const MachineTypedMultiSelect = MultiSelect<ReferenceDataItem>();

const MachineMultiSelect: React.FC<MachineMultiSelectProps> = (props) => {
    const chipRenderer = (r: ReferenceDataItem | SelectItem, onRequestDelete: (event: object) => void) => {
        return (
            <Lookup
                lookupCollection={props.items}
                lookupId={r.Id}
                getIdFromElement={(element) => element.Id}
                render={(item) => <MachineChip deleteButtonAccessibleName={`Delete ${item.Name}`} onRequestDelete={onRequestDelete} machineName={item.Name} />}
                renderFallback={<MissingChip lookupId={r.Id} type={ChipIcon.Machine} deleteButtonAccessibleName={"Delete Missing Resource"} onRequestDelete={onRequestDelete} />}
            />
        );
    };

    return <MachineTypedMultiSelect fieldName="targets" renderChip={chipRenderer} {...props} />;
};

export default MachineMultiSelect;
